<template>
  <div>
    <div class="row content-list lh">
      <div class="col-4 content-list-title no-padding">Wallet</div>
      <div class="col-5 content-list-label">
      <div class="action">
        <Popover popper-class="newpopover tablepadding" placement="bottom-end" v-model="penality">
          <div class="popover-primary">
            <div class="popover-primary-header">
              <h3>Penality</h3>
              <span class="remove-icon" @click="penality=false">
                <svgicon name="cancel" width="10" height="10" :original="true" />
              </span>
            </div>
            <div class="popover-primary-body">
              <!-- <Header /> -->
              <!-- <div v-for="(wallet, idx) in walletList" :key="idx">
                {{wallet.order_number}} - {{getType(wallet.type)}} - {{wallet.amount}}
              </div> -->

              <div class="tablepanel">
              <div class="new">
                <div class="table">
                  <div class="table-header">
                  <div class="table-row">
                    <div class="table-th w200">REASON</div>
                    <div class="table-th w150">INDENT ID</div>
                    <div class="table-th w100">AMOUNT</div>
                  </div>
                </div>
                <div class="table-bgcolor scrolltable">
                <div class="table-row table-rowbg" v-for="(wallet, idx) in walletList" :key="idx">
                  <div class="table-td w200">{{getType(wallet.type)}}</div>
                  <div class="table-td w150">{{(wallet.order_id && wallet.order_id.order_no)}}</div>
                  <div class="table-td w100">{{wallet.amount}}</div>
                </div>
              </div>
              </div>
              </div>
              </div>

            </div>
          </div>
          <div slot="reference">
            <div>
            {{walletList && walletList.length}} Penalities applied
            <div class="notificationicon">
            <svgicon name="info-black" width="12" height="12" :original="true" />
          </div>
          </div>
          </div>
        </Popover>
      </div>
      </div>
      <!-- <div class="col content-list-total"> {{total}} </div> -->
    </div>
  </div>
</template>

<script>
import Header from './Header';
import Row from './Row';
import WalletConstants from '@/constants/wallet';
export default {
  name: 'wallet',
  props: {
    wallets: {
      type: Array
    },
    total: {
      type: Number
    }
  },
  data() {
    return {
      penality: false,
    }
  },
  computed: {
    walletList() {
      return this.wallets;
    },
    walletAmount() {
      return this.walletList.length ? this.walletList.reduce((a, b) => (a.amount + b.amount) ): 0;
    }
  },

  methods: {
    getType(t) {
      const type = WalletConstants.WalletTypeForExcel;
      return type[t];
    }
  }
}
</script>

<style lang='scss' scoped>
.scrolltable{
  height:200px;
  overflow: scroll;
}
</style>
